import '../styles/Footer.css'
import React from 'react'


export default function Footer(){

    return (<>
        <p>Powered by the NuclearManatee</p>
    </>);
}